export default __webpack_public_path__ + "static/christmas-competition-2024-e2114958e20b819d2acb37b3748906ef.jpg";